<button class="action-button" [disabled]="disabled()" mat-button (click)="emitClick()">
  @if (icon(); as icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }

  <ng-content>
    <span>{{ label() }}</span>
  </ng-content>
</button>
